import { LAB_ORDER_STATUS_CONFIG } from "../constants";
import { deriveLabOrderStatus } from "./labOrderStatus";

// How many of a patient's orders a search covers. The backend paginates and has no
// search parameter, so searching fetches one large page and filters it here. A patient
// with more orders than this would have matches outside the window — hence the cap is
// named rather than buried, and the table says so when it bites.
export const SEARCH_FETCH_ROWS = 100;

// What a GP would type looking for an order: the hospital, the laboratory, who ordered
// it, the status they can see, the order reference they were quoted on the phone, or
// what was ordered — "tsh", "coag" (KIN-1977; names only, never clinical details).
const searchableText = (order) => {
  const status = LAB_ORDER_STATUS_CONFIG[deriveLabOrderStatus(order)]?.label ?? "";

  return [
    order.hospitalName,
    order.agencyLabel,
    order.agencyCode,
    order.orderedByName,
    order.messageControlId,
    status,
    ...(order.testNames ?? []),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
};

// Every term must match somewhere, so "cork biochem" narrows rather than widens —
// typing more words should never bring back more rows.
export const filterLabOrders = (orders, search) => {
  const terms = (search ?? "")
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

  if (terms.length === 0) return orders ?? [];

  return (orders ?? []).filter((order) => {
    const text = searchableText(order);

    return terms.every((term) => text.includes(term));
  });
};
